/**
 * Generates a small, deterministic SVG "identicon"-style thumbnail for a project.
 *
 * Real raster screenshots of the artifact are intentionally deferred: capturing
 * the iframe contents would require either (a) loosening the iframe sandbox to
 * allow same-origin so html2canvas can reach in (violates constitution §III), or
 * (b) bundling html2canvas inside the runtime (~150 KB hostile-zone bloat). The
 * identicon below provides a stable visual handle for the project list and
 * keeps `Project.thumbnailDataUrl` populated in the data model.
 */

const PALETTE = [
  ['#0ea5e9', '#1e293b'],
  ['#14b8a6', '#0f172a'],
  ['#f59e0b', '#7c2d12'],
  ['#ef4444', '#450a0a'],
  ['#a855f7', '#1e1b4b'],
  ['#22c55e', '#052e16'],
];

function hash(str: string): number {
  let h = 0;
  for (let i = 0; i < str.length; i++) h = (h * 31 + str.charCodeAt(i)) | 0;
  return Math.abs(h);
}

export function thumbnailFor(input: { id: string; name: string }): string {
  const h = hash(input.id);
  const [bg, fg] = PALETTE[h % PALETTE.length] ?? PALETTE[0]!;
  const initials = input.name
    .split(/\s+/)
    .map((w) => w[0])
    .filter(Boolean)
    .slice(0, 2)
    .join('')
    .toUpperCase() || '?';
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 60" width="80" height="60">
    <rect width="80" height="60" fill="${bg}"/>
    <circle cx="${20 + (h % 30)}" cy="${20 + ((h >> 4) % 20)}" r="14" fill="${fg}" opacity="0.5"/>
    <text x="40" y="36" text-anchor="middle" font-family="ui-sans-serif,system-ui" font-size="20" font-weight="700" fill="white">${initials}</text>
  </svg>`;
  return `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
}
